<template>
  <main class="bg-ip-color-3 fixed w-full h-full pb-4 md:pt-10">
    <figure class="opacity-0 profile-graphic absolute top-8 left-0 max-w-[8rem]">
      <ArrowDouble2/>
    </figure>
    <figure class="opacity-0 profile-graphic absolute bottom-14 right-0 max-w-[7rem]">
      <ArrowSquare/>
    </figure>
    <div class="max-w-md mx-auto h-full w-full">
      <div class="relative h-fit top-1/2 -translate-y-1/2 text-white">
        <div class="opacity-0 profile-item w-fit mx-auto rounded-xl overflow-hidden">
          <figure alt="qr-code" class="p-5">
            <QRCodeVue3
              :value="`https://impacthink.id/${route.params.profileLink}`"
              :width="isLargeScreen ? 300 : 220"
              :height="isLargeScreen ? 300 : 220"
              :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
              :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
              image="/images/logo-white-qr.png"
              :dotsOptions="{
                type: 'square',
                color: '#fff',
                gradient: {
                  type: 'linear',
                  rotation: 0,
                  colorStops: [
                    { offset: 0, color: '#fff' },
                    { offset: 1, color: '#fff' },
                  ],
                },
              }"
              :backgroundOptions="{ color: 'transparent' }"
              :cornersSquareOptions="{ type: 'square', color: '#fff' }"
              :cornersDotOptions="{ type: 'square', color: '#fff' }"
              myclass="my-qur"
              imgclass="img-qr"
            />
          </figure>
        </div>
        <div class="">
          <div class="opacity-0 profile-item text-center text-2xl font-semibold">{{ selectedUser?.name }}</div>
          <div class="profile-item w-16 h-[.1rem] my-2 bg-ip-color-2 opacity-30 mx-auto"></div>
          <div class="opacity-0 profile-item text-center text-base">{{ selectedUser?.role }}</div>
        </div>
        <div class="opacity-0 profile-item flex items-center justify-center">
          <NuxtLink :to="`/${route.params.profileLink}`" class="py-10 relative z-10 h-10 w-full overflow-clip">
            <div class="h-10 max-w-xs w-full relative"></div>
            <div class="absolute top-1/2 h-48 w-full -translate-y-1/2">
              <div class="arrow arrow-first"></div>
              <div class="arrow arrow-second"></div>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </main>

  <div class=" max-w-md mx-auto w-full fixed left-1/2 -translate-x-1/2 bottom-4 md:bottom-6 z-50 px-2">
    <div class="bg-ip-offwhite opacity-0 profile-item border border-gray-100 border-opacity-40 bg-opacity-30 backdrop-blur-lg flex justify-between gap-3 items-center px-3 py-3 shadow-sm rounded-[16px]">
      <figure class="max-w-[7.5rem]">
        <img src="/images/logo-white.png" alt="">
      </figure>
      <div v-if="isInstagramBrowser && isIphoneDevice" class="tooltip tooltip-open flex-shrink-0" data-tip="Long press to save">
        <a :href="`https://impacthink.id/api/download-vcard/?slug=${selectedUser?.slug}`" Download class="inline-block flex-shrink-0 relative w-fit group">
          <div class="absolute w-full h-full bg-ip-color-3 bg-opacity-5 group-hover:scale-y-125 group-hover:scale-x-105 rounded-lg transition-all duration-300"></div>
          <div
            class="relative bg-ip-color-3 z-10 text-sm font-semibold text-white focus:outline-none shadow-lg hover:shadow-md hover:bg-opacity-95 py-2 px-[.65rem] rounded-lg flex gap-2 items-center transition-all duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            Save Contact
          </div>
        </a>
      </div>
      <a v-else :href="`https://impacthink.id/api/download-vcard/?slug=${selectedUser?.slug}`" Download class="inline-block flex-shrink-0 relative w-fit group">
        <div class="absolute w-full h-full bg-ip-color-3 bg-opacity-5 group-hover:scale-y-125 group-hover:scale-x-105 rounded-lg transition-all duration-300"></div>
        <div
          class="relative text-ip-color-3 z-10 text-sm font-semibold bg-ip-color-2 focus:outline-none shadow-lg hover:shadow-md hover:bg-opacity-95 py-2 px-[.65rem] rounded-lg flex gap-2 items-center transition-all duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          Save Contact
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
const { $anime } = useNuxtApp();
const route = useRoute();
const config = useRuntimeConfig();
const isLargeScreen = useMediaQuery('(min-width: 1024px)');

const isInstagramBrowser = ref(false);
const isIphoneDevice = ref(false);

const user = ref([
  {
    photo: '/images/impacthink/lisa.webp',
    name: 'Lisa Imrani',
    first_name: 'Lisa',
    last_name: 'Imrani',
    role: 'Managing Director',
    email: 'lisa@impacthink.id',
    phone: '+6281224799623',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'lisa',
    notes: 'Managing Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/nadia.webp',
    name: 'Nadia Andayani',
    first_name: 'Nadia',
    last_name: 'Andayani',
    role: 'Strategy Director',
    email: 'nadia@impacthink.id',
    phone: '+6281380007982',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'nadia',
    notes: 'Strategy Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/farida.webp',
    name: 'Farida Soemawidjaja',
    first_name: 'Farida',
    last_name: 'Soemawidjaja',
    role: 'Director',
    email: 'farida@impacthink.id',
    phone: '+6285883386914',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'farida',
    notes: 'Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/lia.webp',
    name: 'Lia Handayani',
    first_name: 'Lia',
    last_name: 'Handayani',
    role: 'Marketing Director',
    email: 'lia@impacthink.id',
    phone: '+62818916973',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'lia',
    notes: 'Marketing Director at Impacthink.id.',
  },
]);
const selectedUser = computed(() => user.value.find((user) => user.slug === route.params.profileLink));

useSeoMeta({
  ogUrl: () => `https://impacthink.id/${selectedUser.value?.slug}`,
  title: () => `${selectedUser.value?.name} - ImpacThink`,
  ogTitle: () => `${selectedUser.value?.name} - ImpacThink`,
  twitterTitle: () => `${selectedUser.value?.name} - ImpacThink`,
  description: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  ogDescription: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  twitterDescription: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  ogImage: '/favicon.ico',
  twitterImage: '/favicon.ico',
  twitterCard: 'summary',
});

onMounted(() => {
  if (navigator.userAgent.includes('Instagram')) {
    isInstagramBrowser.value = true;
  }
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream) {
    isIphoneDevice.value = true;
  }

  $anime({
    targets: '.profile-graphic',
    opacity: 1,
    translateY: [100, 0],
    translateX: [-100, 0],
    delay: $anime.stagger(100),
    easing: 'easeInOutQuart',
    duration: 700,
  });

  $anime({
    targets: '.profile-item',
    opacity: 1,
    translateY: [20, 0],
    delay: $anime.stagger(100),
    duration: 800,
  });
});
</script>

<style lang="scss" scoped>

</style>
